import axios from "axios";

const STORE_URL = "https://happyboxstore.com";
const MAIN_PRODUCT_TYPE = "Box";
const ADDON_PRODUCT_TYPE = "Gift";
const CARD_PRODUCT_TYPE = "Card";
var cartItems = null;

const actions = {
    getFeeProduct(context) {
        axios
            .get(`/products/handpacking-fee-5.js`)
            .then(response => response.data)
            .then(data => {
                context.commit("setFeeProduct", data);
            });
    },
    //Get gifts,cards and boxes products
    async getProducts(context) {
        await getCartInfo(context);
        //get products
        let nextPage = null;
        let hasMoreProducts = true;
        let url = "https://api.happyboxstore.com/api/bundle/products";
        while (hasMoreProducts) {
            const res = await fetch(url);
            const data = await res.json();
            nextPage = data.next;
            sortFetchedProducts(data.products);
            url = `https://api.happyboxstore.com/api/bundle/products?page=${nextPage}`;
            if (!data.next) hasMoreProducts = false;
        }
        var savedProducts = JSON.parse(localStorage.getItem("totalAddons"));
        var editBox = JSON.parse(localStorage.getItem("editBox"));
        if (editBox) loadEditCart(addonProductList, mainProductList, cardProductList);
        else if (savedProducts) loadSavedCart(addonProductList);
        //getCustomProducts(addonProductList);
        const params = new URLSearchParams(window.location.search);
        for (const [key, value] of params) {
            if (key == "occasion") context.commit("setSelectedOccasion", value);
            if (key == "product") {
                let product = addonProductList.find(x => x.id == value);
                if (product) {
                    context.commit("updateSelectedAddonProductsNew", {
                        product: product,
                        quantity: 1
                    });
                }
            }
        }

        async function getCartInfo(context) {
            const cartRequest = await axios.get(`${STORE_URL}/cart.js`);
            let cart = cartRequest.data;
            processCart(context, cart);
        }

        function processCart(context, data) {
            const { item_count: cartQty, items } = data;
            // 1) Update cart quantity
            context.commit("setCartQty", cartQty);

            // 2) Extract any box names
            const boxNames = items.map(({ properties }) => properties.boxName).filter(Boolean);
            if (boxNames.length) {
                context.commit("setCartNames", boxNames);
            }

            // Helper to expand a GIST bundle line item into individual variant entries
            const expandBundle = ({ properties, quantity }) => {
                const rawIds = properties._gs_bundle_ids;
                const rawQtys = properties._gs_bundle_quantities;
                const ids = Array.isArray(rawIds) ? rawIds : rawIds.split(",");
                const qtys = Array.isArray(rawQtys) ? rawQtys : rawQtys.split(",");
                return ids.map((id, i) => ({
                    id,
                    quantity: (parseInt(qtys[i], 10) || 0) * quantity
                }));
            };

            // 3) Flatten all items into {id, quantity} entries
            const flatItems = items.flatMap(item =>
                item.product_type === "GIST_BUILDER_PRODUCT"
                    ? expandBundle(item)
                    : [{ id: item.variant_id, quantity: item.quantity }]
            );

            // 4) Group by id and sum quantities
            const groupedMap = flatItems.reduce((acc, { id, quantity }) => {
                acc[id] = (acc[id] || 0) + quantity;
                return acc;
            }, {});

            // 5) Convert back to array form
            cartItems = Object.entries(groupedMap).map(([id, quantity]) => ({
                id,
                quantity
            }));
        }

        function sortFetchedProducts(totalProductList) {
            try {
                const mainProductList = totalProductList.filter(product => {
                    if (
                        product.product_type == MAIN_PRODUCT_TYPE &&
                        product.variants.some(
                            x => x.inventory_quantity > 0 || x.inventory_policy == "continue"
                        )
                    ) {
                        product.maxCapacity = parseInt(product.variants[0].option1);
                        product.variants = product.variants.map(variant => {
                            let cart = cartItems.find(x => x.id == variant.id);
                            if (cart) {
                                variant.inventory_quantity =
                                    variant.inventory_quantity - cart.quantity;
                            }
                            variant.inventory_quantity =
                                variant.inventory_policy == "continue"
                                    ? 9999
                                    : variant.inventory_quantity;
                            variant.available = variant.inventory_quantity > 0;
                            return variant;
                        });
                        return product;
                    } else if (
                        product.product_type == MAIN_PRODUCT_TYPE &&
                        product.title.toLowerCase().includes("custom")
                    ) {
                        product.variants = product.variants.map(variant => {
                            variant.available = true;
                            variant.inventory_quantity = 999;
                            return variant;
                        });

                        return product;
                    }
                });

                var addonProductList = totalProductList.filter(product => {
                    if (
                        product.product_type == ADDON_PRODUCT_TYPE &&
                        product.variants.some(
                            x =>
                                Number(x.price) > 0 &&
                                (x.inventory_quantity > 0 || x.inventory_policy == "continue")
                        )
                    ) {
                        product.tags = product.tags.split(", ");
                        const capacityTag = product.tags.find(tag => tag.indexOf("Capacity_") > -1);
                        if (capacityTag != undefined) {
                            const capacity = parseFloat(capacityTag.split("_")[1]);
                            product.capacity = capacity;
                        }

                        const isOnSale = product.variants.some(x => x.compare_at_price != null);
                        if (isOnSale) {
                            product.tags.push("Filter_Category_Sale");
                        }
                        product.variants = product.variants
                            .filter(x => parseFloat(x.price) > 0)
                            .map(variant => {
                                let cart = cartItems.find(x => x.id == variant.id);
                                if (cart) {
                                    variant.inventory_quantity =
                                        variant.inventory_quantity - cart.quantity;
                                }
                                variant.inventory_quantity =
                                    variant.inventory_policy == "continue"
                                        ? 9999
                                        : variant.inventory_quantity;
                                variant.available = variant.inventory_quantity > 0;
                                variant.sku = variant.sku ? variant.sku : "";
                                variant.featured_image = product.images.find(
                                    x => x.id == variant.image_id
                                );
                                return variant;
                            });

                        return product;
                    }
                });

                addonProductList = addonProductList.filter(
                    x => x.variants && x.variants.length > 0
                );

                const cardProductList = totalProductList
                    .filter(
                        product =>
                            product.product_type == CARD_PRODUCT_TYPE &&
                            product.variants.some(
                                x => x.inventory_quantity > 0 || x.inventory_policy == "continue"
                            )
                    )
                    .map(x => {
                        const isVertical = x.tags.includes("Vertical");
                        x.isVertical = isVertical;

                        return x;
                    });
                var capacityList = mainProductList
                    .map(x => x.variants)
                    .flat()
                    .filter(x => x.available)
                    .map(x => parseInt(x.option1));
                let maxCapacity = Math.max(...capacityList);
                context.commit(
                    "setMainProducts",
                    JSON.parse(JSON.stringify(context.getters.boxProducts.concat(mainProductList)))
                );
                context.commit(
                    "setAddonProducts",
                    JSON.parse(
                        JSON.stringify(context.getters.addonProducts.concat(addonProductList))
                    )
                );
                context.commit(
                    "setCardProducts",
                    JSON.parse(JSON.stringify(context.getters.cardProducts.concat(cardProductList)))
                );
                if (context.getters.maxCapacity < maxCapacity) {
                    context.commit("setMaxCapacity", maxCapacity);
                }
                //Get occasions
                getOccasions(context.state.addonProducts);
            } catch (ex) {
                console.log(ex);
            }
        }
        function getOccasions(addonProductList) {
            const FILTER_PREFIX = "Filter_";
            const VIEW_ALL_TAG = `${FILTER_PREFIX}Category_View All`;

            // 1) Extract all unique “Filter_…” tags
            const uniqueTags = [
                ...new Set(
                    addonProductList.flatMap(({ tags }) =>
                        tags.filter(tag => tag.startsWith(FILTER_PREFIX))
                    )
                )
            ];
            if (uniqueTags.length === 0) return;

            // 2) Turn each tag into { category, title, tag } or drop it
            const filters = uniqueTags
                .map(tag => {
                    const [category, title] = tag.slice(FILTER_PREFIX.length).split("_");
                    return category && title ? { category, title, tag } : null;
                })
                .filter(Boolean);

            // 3) Group by category
            const grouped = filters.reduce((acc, { category, title, tag }) => {
                if (!acc[category]) acc[category] = { category, filters: [] };
                acc[category].filters.push({ title, tag });
                return acc;
            }, {});

            // 4) Commit “Occasion” filters immediately
            if (grouped.Occasion) {
                context.commit("setOccasions", grouped.Occasion.filters);
            }

            // 5) Sort & commit “Category” filters
            if (grouped.Category) {
                const corpCategory = `${context.getters.corpName} Gifts`;

                const priority = {
                    [corpCategory]: 5,
                    "Snacks & Treats": 4,
                    "Brandable Swag": 3,
                    "Tea/Coffee": 2,
                    "Candles": 1,
                    // Sale intentionally lowest
                    Sale: 0
                };

                grouped.Category.filters.sort((a, b) => {
                    // Always push “Sale” to the end
                    if (a.title === "Sale") return 1;
                    if (b.title === "Sale") return -1;
                    // Otherwise sort by our priority map
                    return (priority[b.title] || 0) - (priority[a.title] || 0);
                });

                // Prepend the “View All” option
                grouped.Category.filters.unshift({
                    title: "View All",
                    tag: VIEW_ALL_TAG
                });

                context.commit("setCategories", grouped.Category);
            }
        }
    }
};

export default actions;
